/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : models/auth/index.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Interface definitions for Auth related data
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 12, 2020
 * Description   : Add Interface definitions for Auth related data
 *
 *
 ******************************************************************************/

import { IAppConfig } from 'shared/utils';

export enum EnumTokenType {
  Auth,
  Refresh,
}

interface IAppConfigObj {
  type: EnumTokenType;
  appConfig: IAppConfig;
}

export interface IGetAuthTokenRequestArgs extends IAppConfigObj {
  code: string;
  codeVerifier: string
}

export interface IGetRefreshTokenRequestArgs extends IAppConfigObj {
  refresh_token: string;
}

export interface IUserRoleState {
  role: 'agent' | 'user' | null
}

export interface ITokenState {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export interface IUserInfoState {
  avatar: string;
  given_name: string;
  family_name: string;
  name: string;
  sub: string;
}

export interface IAuthState {
  token: ITokenState | null;
  userInfo: IUserInfoState | null;
  userRole: 'agent' | 'user' | null;
}

export interface IDecodedAccessToken {
  exp: number;
}
